import React, { useState, useEffect, useRef } from 'react';
import { CONFIG } from '../config';

const HeyDJPublicPage = ({ token }) => {
  const [requests, setRequests] = useState([]);
  const [eventName, setEventName] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const intervalRef = useRef(null);

  const fetchRequests = async () => {
    try {
      const resp = await fetch(`${CONFIG.apiBaseUrl}/public/dj-requests/${token}`);
      if (!resp.ok) {
        if (resp.status === 400) throw new Error('Invalid or expired link');
        throw new Error('Failed to fetch DJ requests');
      }
      const data = await resp.json();
      setRequests(data.requests || []);
      if (data.event_name) setEventName(data.event_name);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
    intervalRef.current = setInterval(fetchRequests, 15000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const handleStatusChange = async (timestampId, newStatus) => {
    const prev = requests.map(r => ({ ...r }));
    setRequests(requests.map(r =>
      r.timestamp_id === timestampId ? { ...r, status: newStatus } : r
    ));

    try {
      const resp = await fetch(`${CONFIG.apiBaseUrl}/public/dj-requests/${token}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ timestamp_id: timestampId, status: newStatus }),
      });
      if (!resp.ok) throw new Error('Failed to update status');
    } catch (err) {
      console.error('Status update failed:', err.message);
      setRequests(prev);
    }
  };

  if (error) {
    return (
      <div className="addme-page">
        <div className="addme-container">
          <h2>#HeyDJ</h2>
          <div className="error-message">{error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="addme-page">
      <div className="addme-container" style={{ maxWidth: '800px' }}>
        <h2>#HeyDJ {eventName && <span style={{ fontWeight: 'normal', fontSize: '0.7em' }}>- {eventName}</span>}</h2>

        <div className="messages-container">
          {loading ? (
            <div className="loading-text">Loading requests...</div>
          ) : requests.length === 0 ? (
            <p>No song requests yet.</p>
          ) : (
            <>
              <div className="messages-count">
                {requests.length} request{requests.length !== 1 ? 's' : ''}
              </div>
              <div className="messages-table-wrapper">
                <table className="messages-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Song Request</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {requests.map((req, idx) => (
                      <tr key={req.timestamp_id || idx} className={`dj-row-${req.status || 'unmarked'}`}>
                        <td>{idx + 1}</td>
                        <td>{req.message_body}</td>
                        <td>
                          <div className="dj-status-group">
                            <button
                              className={`dj-status-btn ${req.status === 'unmarked' ? 'active-unmarked' : ''}`}
                              onClick={() => handleStatusChange(req.timestamp_id, 'unmarked')}
                              title="Unmarked"
                            >&#9679;</button>
                            <button
                              className={`dj-status-btn ${req.status === 'approved' ? 'active-approved' : ''}`}
                              onClick={() => handleStatusChange(req.timestamp_id, 'approved')}
                              title="Approved"
                            >&#10003;</button>
                            <button
                              className={`dj-status-btn ${req.status === 'rejected' ? 'active-rejected' : ''}`}
                              onClick={() => handleStatusChange(req.timestamp_id, 'rejected')}
                              title="Rejected"
                            >&#10007;</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>

        <p style={{ fontSize: '12px', color: '#888', marginTop: '20px', textAlign: 'center' }}>
          Auto-refreshes every 15 seconds
        </p>
      </div>
    </div>
  );
};

export default HeyDJPublicPage;
